import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=2178d644&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=2178d644&lang=css&scoped=true&"
import style1 from "./Chat.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Chat.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2178d644",
  null
  
)

export default component.exports